import {fetchChecksumsJSONSuccess} from "modules/actions";
import {createReducer} from "redux-act";

const defaultState: ReturnType<typeof fetchChecksumsJSONSuccess>["payload"] = {};

export const checksums = createReducer<typeof defaultState>({}, defaultState).on(
	fetchChecksumsJSONSuccess,
	(_state, payload) => payload
);
